<div class="relative overflow-visible border-2 rounded-[14px] w-[400px] mobile:w-[300px] h-auto min-h-[400px] mobile:h-[300px] p-4 flex flex-col gap-5 justify-evenly"
    *ngIf="planInfo">
    <div *ngIf="planInfo.is_recommended"
        class="absolute top-[-24px] right-[-24px] w-24 h-24 bg-[#F00CFE] text-white text-sm font-semibold flex items-center justify-center rounded-full text-center shadow-md p-2 leading-tight rotate-12">
        {{ 'settings.smart_plan_badge' | transloco }}
    </div>


    <p class="text-3xl mobile:text-xl mt-4 text-black font-bold min-h-[20px]">
        {{planInfo.title.toUpperCase()}}</p>

    <p class="text-4xl mobile:text-2xl font-bold text-black min-h-[20px]">€{{monthlyPrice}} <span
            class="text-sm mobile:text-sm font-normal text-neutral-500">/ {{
            'shared.month' | transloco
            }} {{
            'settings.start_plan_note' | transloco: { number_of_locations: planInfo.included_locations}
            }}</span></p>

    <p class="text-sm mobile:text-sm text-neutral-500 min-h-[50px]">{{ showFullDescription ?
        (translatedDescription | transloco) : ((translatedDescription | transloco) | slice:0:150) }} <span
            *ngIf="translatedDescription.length > 150" class="cursor-pointer hover:underline text-primary"
            (click)="toggleDescription()">
            @if(showFullDescription) { {{ 'shared.view_less' | transloco }} } @else { {{ 'shared.view_more' |
            transloco }} }
        </span>
    </p>

    <ul *ngIf="planInfo.membership_type == startPlan" class="text-black text-sm mobile:text-xs min-h-[90px]">
        <li class="flex gap-2 items-center">
            <img src="assets/icons/check.svg" alt="{{ 'shared.icon' | transloco }}" class="w-[20px] h-[20px]">
            <p>{{ 'settings.start_plan_benefit_1' | transloco }}</p>
        </li>
        <li class="flex gap-2 items-center">
            <img src="assets/icons/check.svg" alt="{{ 'shared.icon' | transloco }}" class="w-[20px] h-[20px]">
            <p>{{ 'settings.start_plan_benefit_2' | transloco }}</p>
        </li>
        <li class="flex gap-2 items-center">
            <img src="assets/icons/check.svg" alt="{{ 'shared.icon' | transloco }}" class="w-[20px] h-[20px]">
            <p>{{ 'settings.start_plan_benefit_3' | transloco }}</p>
        </li>
    </ul>

    <ul *ngIf="planInfo.membership_type == smartPlan" class="text-black text-sm mobile:text-xs min-h-[90px]">
        <li class="flex gap-2 items-center">
            <img src="assets/icons/check.svg" alt="{{ 'shared.icon' | transloco }}" class="w-[20px] h-[20px]">
            <p>{{ 'settings.smart_plan_benefit_1' | transloco }}</p>
        </li>
        <li class="flex gap-2 items-center">
            <img src="assets/icons/check.svg" alt="{{ 'shared.icon' | transloco }}" class="w-[20px] h-[20px]">
            <p>{{ 'settings.smart_plan_benefit_2' | transloco }}</p>
        </li>
        <li class="flex gap-2 items-center">
            <img src="assets/icons/check.svg" alt="{{ 'shared.icon' | transloco }}" class="w-[20px] h-[20px]">
            <p>{{ 'settings.smart_plan_benefit_3' | transloco }}</p>
        </li>
    </ul>

    <div class="max-w-screen-sm w-full h-[50px] mt-2 mb-4">
        <app-custom-button buttonText="{{ 'settings.select_plan' | transloco }}" [isDisabled]="false"
            [backgroundColor]="'bg-primary'" [textColor]="'text-white'" borderColor="border-primary"
            hoverBorderColor="hover:border-primary-1200" hoverBackgroundColor="hover:bg-primary-1200"
            (buttonClick)="planSelected()">
        </app-custom-button>
    </div>
</div>